import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();
  const navigationType = useNavigationType(); // 'PUSH', 'POP', 'REPLACE'
  const isNavigatingBack = useRef(false);

  useEffect(() => {
    // 뒤로가기 감지
    isNavigatingBack.current = navigationType === 'POP';
  }, [navigationType]);

  useEffect(() => {
    // hash(#section)이 있는 경우 (특정 섹션 이동) → 무시
    if (location.hash) return;

    // 뒤로가기 중이면 무시
    if (isNavigatingBack.current) return;

    // ✅ 일반 이동 시만 작동
    const scrollToTop = () => {
      if (window.lenis && typeof window.lenis.scrollTo === 'function') {
        window.lenis.scrollTo(0, {
          duration: 0.8,
          easing: (t) => t * (2 - t),
        });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };

    requestAnimationFrame(scrollToTop);
  }, [location.pathname, location.hash]); // hash 감지도 포함

  return null;
};

export default ScrollToTop;
